import { shouldShowElement } from '../../../utils/messagesReappearance';
import { OPPORTUNITIES_BANNER_TYPE, OPPORTUNITIES_MESSAGES_ELEMENTS } from '../constants';
const Views = self => ({
    get opportunitiesBannerType() {
        // only if user did not visit the promo page display feature announcement - based reappearance algo
        if (!self.firstPromoVisit && shouldShowElement(OPPORTUNITIES_MESSAGES_ELEMENTS.FEATURE_ANN)) {
            return OPPORTUNITIES_BANNER_TYPE.FEATURE_ANNOUNCEMENT;
        }
        // only if user has already exposed to promo page and he has new signals
        if (self.firstPromoVisit && self.newSignals) {
            return OPPORTUNITIES_BANNER_TYPE.NEW_OPPORTUNITIES;
        }
        return OPPORTUNITIES_BANNER_TYPE.NO_BANNER;
    },
});
export default Views;
